import { render, staticRenderFns } from "./flats-card.vue?vue&type=template&id=7823e768"
import script from "./flats-card.vue?vue&type=script&lang=js"
export * from "./flats-card.vue?vue&type=script&lang=js"
import style0 from "./flats-card.vue?vue&type=style&index=0&id=7823e768&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports